import { Grid, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Chip } from 'common';
import React from 'react';
import { useStore } from './context';

const useStyles = makeStyles(() => ({
  container: {
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.08)',
    backgroundColor: '#fff',
    height: '100%',
    padding: 16,
  },
  skillsTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.25,
    textAlign: 'left',
    color: '#60676f',
    paddingBottom: 16,
  },
  emptySkills: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: 0.33,
  },
}));

const SkillsSet = ({ label, skillSet }) => {
  const classes = useStyles();
  const { state, dispatch } = useStore();

  const onDeleteSkill = (skill) => {
    dispatch({
      type: 'SET_SKILL_SET',
      skillSet,
      value: state[skillSet].filter((s) => s !== skill),
    });
  };

  return (
    <Grid container classes={{ root: classes.container }}>
      <Grid item xs={12} classes={{ root: classes.gridContainer }}>
        <Typography classes={{ root: classes.skillsTitle }}>{label}</Typography>
        {state[skillSet].length ? (
          state[skillSet].map((skill) => (
            <Chip
              key={skill}
              label={skill}
              onDeleteChip={onDeleteSkill}
              onClick={onDeleteSkill}
              showDelete
            />
          ))
        ) : (
          <Typography
            classes={{ root: clsx(classes.skillsTitle, classes.emptySkills) }}
          >
            Add Skills to skill set
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default SkillsSet;
